import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { gamificationBanners } from "../../services/common/CommonUtils";
import { GetCacheKey } from "../../services/common/utils";
import ExclusiveModal from "../common/exclusive-modal";
import { Pagination } from 'swiper';

const PromoswiperComponent = (pmsitem) => {
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState();
  const navigate = useNavigate()
  const [srvList, setSrvList] = useState([]);
  const toggleModal = () => {
    setShowModal(!showModal);
  }
  const redirectionFun = (item) => {
    if (item?.external != null && item?.external != undefined &&
      item?.external != "" && (item?.external == "True" || item?.external == "true" || item?.external == true)
       && item?.redirecturl.indexOf("http") >= 0) {
      window.open(item.redirecturl, '_blank');
    }
    else {
      // navigate("/" + item.redirecturl);
      toggleModal()
      // return false;
    }
  };

  const gamificationApi = useQuery(
    [
      GetCacheKey("HOME_DASHBOARD_URL"),
      pmsitem?.pmsitem.method,
      JSON.parse(pmsitem?.pmsitem.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
    }
  );
  useEffect(() => {
    if (gamificationApi.isSuccess && gamificationApi?.data?.data) {
      // console.log(
      //   gamificationBanners(gamificationApi?.data?.data?.response?.dynamictypes)
      // );
      setSrvList(
        gamificationBanners(gamificationApi?.data?.data?.response?.dynamictypes)
      );
    }
  }, [gamificationApi?.data?.data, gamificationApi.isSuccess]);

   if(gamificationApi?.isLoading || gamificationApi?.isFetching){
    return(
      <div class="mb-4 shimmerBG shimmer-img-md bor border-radious15">
      </div>
    );
   }

  return (
    <div class={`dls-sprint13-comp ${srvList?.length === 0 ? '' : 'mb-4'}`}>
      {/* <div className="flex_grp_between mb-3">
        <h3 className="section_title_light mb-0">Promotions</h3>
        <a className="hyperlink">
          View All
          <img
            src={process.env.PUBLIC_URL + "/assets/images/right_arrow_red.svg"}
            alt=""
            title=""
          />
        </a>
      </div> */}
      <Swiper
        className="swiper-container dls13_promo_swiper1"
        modules={[Pagination]}
        spaceBetween={12}
        slidesPerView={1}
        pagination={{
          clickable: true,
        }}
        onSlideChange={() => console.log("slide change")}
        onSwiper={(swiper) => console.log(swiper)}
      >
        {srvList.map((item, index) => (
          <SwiperSlide key={`index_${index}`} onClick={() => redirectionFun(item)}>
            <a>
              <picture>
                <img src={item.imageurl} width="100%" alt="" title="" className='border-radius15' />
              </picture>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
      <ExclusiveModal show={showModal} toggleModal={toggleModal} />
    </div>
  );
};
export default PromoswiperComponent;
